<template>
  <div class="modal fade" id="modal-sale-details" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">Détail de la vente - {{ sale?.reference }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>

        <div class="modal-body">
          <div v-if="sale">
            <div class="mb-3">
              <strong>Date :</strong> {{ sale.saleDate | dateFormat }}<br>
              <strong>Client :</strong> {{ sale.clientName || 'N/A' }}<br>
              <strong>Vendeur :</strong> {{ sale.sellerName }}
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-hover text-nowrap">
                <thead class="bg-light">
                <tr>
                  <th>Produit</th>
                  <th>Qté demandée</th>
                  <th>Qté validée</th>
                  <th>Prix unitaire</th>
                  <th>Sous-total</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!sale.saleLines?.length">
                  <td colspan="5" class="text-muted">Aucune ligne de vente</td>
                </tr>
                <tr v-for="line in sale.saleLines" :key="line.id">
                  <td>{{ line.productCode }}</td>
                  <td>{{ line.requestedQuantity }}</td>
                  <td>{{ line.validatedQuantity }}</td>
                  <td>{{ line.unitPrice | currency }}</td>
                  <td>{{ (line.unitPrice * line.validatedQuantity) | currency}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="text-end mt-3">
              <h5>Total : <strong>{{ sale.totalAmount | currency }}</strong></h5>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalSaleDetails",
    props: {
      sale: Object
    },
    methods: {

    }
  };
</script>
